<template>
  <b-badge v-if="action==='permit'" variant="success">{{ action }}</b-badge>
  <b-badge v-else-if="action==='deny'" variant="danger">{{ action }}</b-badge>
  <b-badge v-else-if="action==='reject'" variant="warning">{{ action }}</b-badge>
  <b-badge v-else variant="primary">{{ action }}</b-badge>
</template>

<script>

export default {
  name: 'FWMLv2ActionViz',
  props: {
    action: {
      type: Object,
      required: true
    }
  },
}
</script>
